import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sn-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss'],
})
export class WarningDialogComponent {
  constructor(private readonly _dialogRef: MatDialogRef<WarningDialogComponent>) {}

  public close(): void {
    this._dialogRef.close();
  }
}
